import React, {
  Component
} from 'react';
import {
  connect
} from 'react-redux';
import {
  push
} from 'react-router-redux';
import {
  Segment
} from 'semantic-ui-react';
import feathersConnect from './../../../providers/feathersConnect';
import AList from './../../auto/AList';

const PAGE_RANGE = 10;

class LocalidadesView extends Component {

  constructor (props) {
    super(props);

    this.LocalidadService = this.props.feathers.service('/api/localidades');
    this.DepartamentoService = this.props.feathers.service('/api/departamentos');
  }

  componentDidMount () {

  }

  static mapStateToProps (state) {
    return {
      routing: state.routing,
      authentication: state.authentication.toJS({ deep: true })
    };
  }

  static mapDispatchToProps (dispatch) {
    return {
      navigate: (path) => {
        dispatch(push(path));
      }
    };
  }

  render () {
    let dptoSelectConfig = {
      service: this.DepartamentoService,
      mapFunction: (departamento, index) => {
        return {
          key: index,
          text: departamento.nombre,
          value: departamento.id
        };
      }
    };

    return (
      <div>
        <AList
          pageRange={PAGE_RANGE}
          mapFunction={(localidad) => ({
            id: localidad.id,
            header: `${localidad.nombre}`,
            description: `${localidad.departamento.nombre}`
          })}
          service={this.LocalidadService}
          form={{
            fields: [
              ['!Nombre', 'nombre', 'input', 8],
              ['!Departamento', 'DepartamentoId', 'asyncselect', 8, dptoSelectConfig]
            ],
            service: this.LocalidadService
          }} />
      </div>
    );
  }
}

export default feathersConnect(
  connect(
    LocalidadesView.mapStateToProps,
    LocalidadesView.mapDispatchToProps
  )(LocalidadesView)
);



// WEBPACK FOOTER //
// ./client/components/pages/misc/LocalidadesView.js